import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';

const Slider3 = () => {
  const fadeFrames = '[{"from":"opacity:0;","speed":1000,"to":"o:1;","delay":0,"ease":"Power4.easeOut"},{"delay":"wait","speed":1000,"to":"opacity:0;","ease":"Power4.easeOut"}]';
  const titleAndTextFrames = '[{"delay":"+790","speed":1500,"sfxcolor":"#fff","sfx_effect":"blockfromleft","frame":"0","from":"z:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]';
  const buttonFrames = '[{"from":"y:100px(R);opacity:0;","speed":2000,"to":"o:1;","delay":2000,"ease":"Power4.easeOut"},{"delay":"wait","speed":1000,"to":"y:-50px;opacity:0;","ease":"Power2.easeInOut"}]';

  const slides = [
    {
      id: '901',
      index: 'rs-901',
      image: require('./../../images/slider/kitchen.png'),
      heading: <div>Spaces You Will Love</div>,
      text: <>From full-home remodels to detail-focused upgrades, we bring thoughtful design and quality craftsmanship to every project.</>,
    },
    {
      id: '902',
      index: 'rs-902',
      image: require('./../../images/slider/bathroom.png'),
      heading: <div>Vision to Reality</div>,
      text: <>We manage every stage with clear communication, reliable timelines, and meticulous execution so your renovation feels seamless.</>,
    },
    {
      id: '903',
      index: 'rs-903',
      image: require('./../../images/slider/home.png'),
      heading: <div>Built to Last</div>,
      text: <>Our team delivers durable, beautiful results that elevate comfort, value, and everyday living for years to come.</>,
    },
  ];

  useEffect(() => {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', function () {
          resolve();
        });
        script.addEventListener('error', function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript('./assets/js/rev-script-3.js');
  }, []);

  return (
    <>
      <div id="welcome_wrapper" className="rev_slider_wrapper fullscreen-container" data-alias="goodnews-header" data-source="gallery" style={{ background: '#eeeeee', padding: 0 }}>
        <div id="slider-boxed" className="rev_slider fullscreenbanner" style={{ display: 'none' }} data-version="5.4.3.1">
          <ul>
            {slides.map((slide) => (
              <li
                key={slide.id}
                data-index={slide.index}
                data-transition="fade"
                data-slotamount="default"
                data-hideafterloop={0}
                data-hideslideonmobile="off"
                data-easein="default"
                data-easeout="default"
                data-masterspeed="default"
                data-thumb={slide.image}
                data-rotate={0}
                data-fstransition="fade"
                data-fsmasterspeed={300}
                data-fsslotamount={7}
                data-saveperformance="off"
                data-title
                data-param1
                data-param2
                data-param3
                data-param4
                data-param5
                data-param6
                data-param7
                data-param8
                data-param9
                data-param10
                data-description
              >
                <img src={slide.image} alt="" data-lazyload={slide.image} data-bgposition="center center" data-bgfit="cover" data-bgparallax={4} className="rev-slidebg" data-no-retina />

                <div
                  className="tp-caption tp-shape tp-shapewrapper "
                  id={`slide-${slide.id}-layer-0`}
                  data-x="['center','center','center','center']"
                  data-hoffset="['0','0','0','0']"
                  data-y="['middle','middle','middle','middle']"
                  data-voffset="['0','0','0','0']"
                  data-width="full"
                  data-height="full"
                  data-whitespace="nowrap"
                  data-type="shape"
                  data-basealign="slide"
                  data-responsive_offset="off"
                  data-responsive="off"
                  data-frames={fadeFrames}
                  data-textalign="['left','left','left','left']"
                  data-paddingtop="[0,0,0,0]"
                  data-paddingright="[0,0,0,0]"
                  data-paddingbottom="[0,0,0,0]"
                  data-paddingleft="[0,0,0,0]"
                  style={{ zIndex: 1, backgroundColor: 'rgba(0, 0, 0, 0.6)', borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 0 }}
                />

                <div
                  className="tp-caption tp-resizeme"
                  id={`slide-${slide.id}-layer-2`}
                  data-x="['left','left','left','left']"
                  data-hoffset="['50','130','130','130']"
                  data-y="['top','top','top','top']"
                  data-voffset="['240','240','180','200']"
                  data-fontsize="['72','72','62','52']"
                  data-lineheight="['82','82','72','62']"
                  data-width="['700','700','700','500']"
                  data-height="['none','none','none','none']"
                  data-whitespace="['normal','normal','normal','normal']"
                  data-type="text"
                  data-responsive_offset="on"
                  data-frames={titleAndTextFrames}
                  data-textalign="['left','left','left','left']"
                  data-paddingtop="[5,5,5,5]"
                  data-paddingright="[0,0,0,0]"
                  data-paddingbottom="[0,0,0,0]"
                  data-paddingleft="[0,0,0,0]"
                  style={{ zIndex: 13, whiteSpace: 'normal', fontWeight: 700, color: '#fff', borderWidth: 0, fontFamily: '"Poppins", sans-serif', textTransform: 'uppercase' }}
                >
                  {slide.heading}
                </div>

                <div
                  className="tp-caption tp-resizeme"
                  id={`slide-${slide.id}-layer-4`}
                  data-x="['left','left','left','left']"
                  data-hoffset="['50','130','130','130']"
                  data-y="['top','top','top','top']"
                  data-voffset="['410','410','350','340']"
                  data-fontsize="['20','20','28','26']"
                  data-lineheight="['28','28','48','38']"
                  data-width="['600','600','700','500']"
                  data-height="['none','none','none','none']"
                  data-whitespace="['normal','normal','normal','normal']"
                  data-type="text"
                  data-responsive_offset="on"
                  data-frames={titleAndTextFrames}
                  data-textalign="['left','left','left','left']"
                  data-paddingtop="[5,5,5,5]"
                  data-paddingright="[0,0,0,0]"
                  data-paddingbottom="[0,0,0,0]"
                  data-paddingleft="[0,0,0,0]"
                  style={{ zIndex: 13, whiteSpace: 'normal', fontWeight: 500, color: '#fff', borderWidth: 0, fontFamily: '"Poppins", sans-serif' }}
                >
                  {slide.text}
                </div>

                {false && <div
                  className="tp-caption tp-resizeme"
                  id={`slide-${slide.id}-layer-5`}
                  data-x="['left','left','left','left']"
                  data-hoffset="['50','130','130','130']"
                  data-y="['top','top','top','top']"
                  data-voffset="['500','520','540','480']"
                  data-lineheight="['none','none','none','none']"
                  data-width="['300','300','300','300']"
                  data-height="['none','none','none','none']"
                  data-whitespace="['normal','normal','normal','normal']"
                  data-type="text"
                  data-responsive_offset="on"
                  data-frames={buttonFrames}
                  data-textalign="['left','left','left','left']"
                  data-paddingtop="[0,0,0,0]"
                  data-paddingright="[0,0,0,0]"
                  data-paddingbottom="[0,0,0,0]"
                  data-paddingleft="[0,0,0,0]"
                  style={{ zIndex: 100, textTransform: 'uppercase' }}
                >
                  <NavLink to="/about" className="site-button btn-effect">More About</NavLink>
                </div>}
              </li>
            ))}
          </ul>
          <div className="tp-bannertimer tp-bottom" style={{ visibility: 'hidden !important' }} />
        </div>
      </div>
    </>
  );
};

export default Slider3;
